import { useEffect, useRef } from 'react';
import { motion } from 'motion/react';

import styles from './Message.module.css';

export const Message = ({ message, rotateSign, speed }) => {
  const videoRef = useRef(null);
  const initDelay = speed / 1000;

  const videoUrl = message.attachments?.[0]?.url;
  const videoPoster = message.attachments?.[0]?.poster;

  useEffect(() => {
    let idTimeout = '';
    if (videoRef.current) {
      idTimeout = setTimeout(() => {
        videoRef.current.play().catch((error) => {});
      }, speed + 600);
    } else if (idTimeout) {
      clearTimeout(idTimeout);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [initDelay]);

  return (
    <div
      className={styles.wrapper}
      style={{
        transform:
          rotateSign === '+' ? 'translateY(-4rem)' : 'translateY(7rem)',
      }}
    >
      <div className={styles.msg}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className={styles.msgVideo}
          style={{
            width: rotateSign === '+' ? '34rem' : '48rem',
            height: rotateSign === '+' ? '34rem' : '48rem',
          }}
        >
          <video
            playsInline
            ref={videoRef}
            muted="muted"
            loop
            style={{ padding: rotateSign === '+' ? '7%' : '6%' }}
          >
            <source
              src={videoUrl}
              type="video/webm"
              poster={videoPoster || ''}
            />
          </video>
        </motion.div>
      </div>
    </div>
  );
};
